import { PILLARS } from '../constants';
import { taskById } from '../runner/tasks';

// Display order is ours; the backend guarantees no particular order. A pillar
// with no entry in PILLARS has no label or accent, so it would render as a raw
// slug — drop it rather than show that.
export function orderedPillars(dashboard) {
  const pillars = dashboard?.pillars;
  if (!Array.isArray(pillars)) return [];
  return PILLARS.map((meta) => pillars.find((p) => p?.id === meta.id)).filter(Boolean);
}

// The task registry is the single source of truth for what this build can run.
// A second hardcoded id list would drift from it the first time a task lands.
export function runnableRoutineGames(dashboard) {
  const games = dashboard?.todayRoutine?.games;
  if (!Array.isArray(games)) return [];
  return games.filter((g) => taskById(g?.id));
}

// The dashboard's pillars[] and the battery's pillars[] are different queries
// answering different questions, and they are not sorted the same way. The
// dashboard list is derived from the server's SURFACED pillar constant and is a
// set of SCORE SLOTS. The battery list is derived from the registered
// assessment instruments and is the set of RUNNABLE assessments — it is also
// the only place `nextTaskId` exists. They have already disagreed once, when
// three pillars sat on the dashboard as overdue while POST /assessment/start
// 404'd for all three. Startability is a battery question. Never infer it from
// the dashboard.
export function startablePillarIds(battery) {
  const pillars = battery?.pillars;
  if (!Array.isArray(pillars)) return new Set();
  return new Set(pillars.map((p) => p?.pillar).filter(Boolean));
}

// The instrument the rotation will administer next for a pillar, or null. Only
// the battery knows this; it rotates by finalized-run count through the
// pillar's alphabetically sorted instrument pool.
export function nextTaskIdFor(battery, pillarId) {
  const pillars = battery?.pillars;
  if (!Array.isArray(pillars)) return null;
  return pillars.find((p) => p?.pillar === pillarId)?.nextTaskId ?? null;
}
